import { query } from 'src/utils/request';

// 获取专家库列表
export function getExpertList(data) {
  return query('/zlb/api/mbp/baida/expert/page', {
    method: 'POST',
    data,
  });
}

// 删除专家
export const deleteExpert = expertId => {
  return query(`/zlb/api/mbp/baida/expert/delete/${expertId}`, {
    method: 'POST',
  });
};

// 校验身份证号
export const checkExpertCertificateNumber = data => {
  return query('/zlb/api/mbp/baida/expert/check', {
    method: 'POST',
    data,
  });
};

// 专家详情查询
export const getExpertDetail = params => {
  return query('/zlb/api/mbp/baida/expert/info', {
    method: 'GET',
    params,
  });
};

// 新增专家
export const addExpertPost = data => {
  return query('/zlb/api/mbp/baida/expert/add', {
    method: 'POST',
    data,
  });
};

// 更新专家
export const updateExpert = data => {
  return query('/zlb/api/mbp/baida/expert/update', {
    method: 'POST',
    data,
  });
};
// 获取职级枚举
export const getJobLevelList = () => {
  return query('/zlb/api/mbp/baida/expert/level', {
    method: 'get',
  });
};
